module.exports = __webpack_public_path__ + "img/forstwart.012e3966.jpg";